<script>
import router from '@/router';
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import GroupOpportunitiesForm from '@/components/GroupOpportunitiesForm';
import axios from 'axios';
export default {
	page: {
		title: 'Volunteer System',
		meta: [
			{
				name: 'Volunteer System',
			},
		],
	},
	components: { Header, Footer, GroupOpportunitiesForm },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			userData: {
				id: null,
				user_type_id: null,
				location_id: null,
				token: null,
			},
			modal_consent: false,
			alert_active: false,
			alert_text: null,
		};
	},
	mounted() {
		this.getHomeAlert();
	},
	methods: {
		locationsModel(userTypeId) {
			localStorage.removeItem('web_user');
			this.userData.user_type_id = userTypeId;
			localStorage.setItem('web_user', JSON.stringify(this.userData));
			if (userTypeId != null) {
				this.modal_consent = false;
				this.$bvModal.show('requirementModal');
			}
		},
		gotoNextPage() {
			router.push({ name: 'locations' });
		},
		consentToggle(event) {
			if (event.target.checked) {
				this.modal_consent = true;
			} else {
				this.modal_consent = false;
			}
		},
		groupVolunteerModal() {
			this.$bvModal.show('groupVolunteerModal');
		},
		groupVolunteerFormSubmission() {
			console.log('Good');
		},
		getHomeAlert() {
			axios.get('/user/options?option_group=homepage').then((res) => {
				this.alert_text = res.data.response[1].option_value;
				this.alert_active = res.data.response[0].option_value == 1 ? true : false;
			});
		},
	},
};
</script>

<template>
	<div class="v-cloak--hidden">
		<Header></Header>
		<section id="hero" class="container-fluid">
			<div class="row mx-0">
				<div class="content col">
					<h3 class="title text-uppercase mb-5">Get Involved</h3>
				</div>
			</div>
			<div class="row mx-0">
				<div class="col-12 cta d-flex flex-column align-items-center flex-md-row justify-content-center align-items-start">
					<b-button v-on:click="locationsModel(3)" variant="custom" class="text-uppercase">
						<span>Mentor</span>
					</b-button>

					<b-button v-on:click="locationsModel(4)" variant="custom" class="text-uppercase">
						<span>Volunteer</span>
					</b-button>
				</div>
			</div>
			<!-- MODAL START -->
			<b-modal id="requirementModal" centered size="lg" title="Requirements" title-class="font-18" hide-footer>
				<div class="row">
					<div class="col-12">
						<p>All mentors and volunteers must have two (2) years of freedom from any substance use dependence, treatment, or significant law violations.</p>

						<ul>
							<li>Mentors must be 25 years or older and have a valid driver's license.</li>
							<li>If you are undecided about whether you would rather mentor or volunteer, please explore the info pages for both options and then fill out the application for the role that fits you best.</li>
						</ul>

						<div class="form-group mt-5 d-flex align-items-center">
							<label for="understand_consent" class="h5">
								<input class="form-check-input mt-0 m-1" style="width: 20px; height: 20px" type="checkbox" id="understand_consent" v-on:change="consentToggle($event)" />
								<span>I Understand</span>
							</label>
						</div>
						<div class="d-flex justify-content-center mb-5">
							<b-button type="button" variant="custom" v-on:click="gotoNextPage()" :class="modal_consent ? '' : 'pe-none bg-secondary bg-soft'">Next</b-button>
						</div>
					</div>
				</div>
			</b-modal>
			<!-- MODAL END -->

			<!-- MODAL START Group Volunteer -->
			<b-modal id="groupVolunteerModal" centered size="lg" title="Group Opportunities" title-class="font-18" hide-footer>
				<GroupOpportunitiesForm></GroupOpportunitiesForm>
			</b-modal>
			<!-- MODAL END Group Volunteer -->
		</section>
		<section id="content">
			<div class="container">
				<div class="row mx-0" v-if="alert_active">
					<div class="col-12 mb-5" v-if="alert_text">
						<div class="alert alert-info">
							<i class="h3 fa fa-info-circle"></i><div class="h3" v-html="alert_text"></div>
						</div>
					</div>
				</div>

				<div class="row mx-0">
					<!-- card -->
					<div class="col-12 col-lg-6 card-box">
						<div class="block">
							<h2 class="title">For Mentors</h2>
							<div class="card-body">
								<p>Become a mentor and walk alongside a MnTC client throughout the program and beyond. Mentors support clients in their faith journey and provide real-life application through conversation and activities!</p>
								<b-button v-on:click="locationsModel(3)" variant="custom">Explore Becoming a Mentor</b-button>
							</div>
						</div>
					</div>
					<!--/. card -->

					<!-- card -->
					<div class="col-12 col-lg-6 card-box">
						<div class="block">
							<h2 class="title">For Volunteers</h2>
							<div class="card-body">
								<p>Become a volunteer and serve our clients and staff in a variety of practical ways at one of our many locations. You can even sign up for a group activity and invite your family, friends, or coworkers!</p>
								<b-button v-on:click="locationsModel(4)" variant="custom">Explore Becoming a Volunteer</b-button>
							</div>
						</div>
					</div>
					<!--/. card -->
				</div>
			</div>
		</section>
		<Footer></Footer>
	</div>
</template>
<style scoped></style>
